import {z} from '@hono/zod-openapi';

import {conversationUser} from '../user/conversationUser';

export const conversationDetail = z.object({
  id: z.string().uuid().openapi({
    description: 'ID of requested conversation',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  tenantId: z.string().uuid().openapi({
    description: 'ID of tenant',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  isActive: z.boolean().openapi({
    description: 'Whether the conversation is active',
    example: true,
  }),
  createdAt: z.string().datetime().openapi({
    description: 'Timestamp when the conversation was created',
    example: '2021-01-01T00:00:00.000Z',
  }),
  updatedAt: z.string().datetime().openapi({
    description: 'Timestamp when the conversation was updated',
    example: '2021-01-01T00:00:00.000Z',
  }),
  users: z.array(conversationUser).openapi({
    description: 'Users in the conversation',
  }),
});

export type ConversationDetail = z.infer<typeof conversationDetail>;
